import script from "./manage-name.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-name.vue?vue&type=script&lang=ts&setup=true"

import "./manage-name.vue?vue&type=style&index=0&id=b597990c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b597990c"]])

export default __exports__